'use client'

import { useEffect } from 'react'
import { event } from '@/lib/analytics'

export function EnhancedAnalytics() {
  useEffect(() => {
    // Track form interactions
    const trackFormInteractions = () => {
      const forms = document.querySelectorAll('form')
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
          const formId = form.id || form.className || 'unknown_form'
          event({
            action: 'form_submit',
            category: 'engagement',
            label: formId
          })
        })
      })
    }

    // Track outbound links
    const trackOutboundLinks = () => {
      const links = document.querySelectorAll('a[href^="http"]')
      links.forEach((link) => {
        const href = link.getAttribute('href')
        if (href && !href.includes(window.location.hostname)) {
          link.addEventListener('click', () => {
            event({
              action: 'click',
              category: 'outbound_link',
              label: href
            })
          })
        }
      })
    }

    // Track file downloads
    const trackFileDownloads = () => {
      const downloadLinks = document.querySelectorAll('a[download], a[href*=".pdf"], a[href*=".doc"], a[href*=".xls"], a[href*=".zip"]')
      downloadLinks.forEach((link) => {
        const href = link.getAttribute('href')
        link.addEventListener('click', () => {
          event({
            action: 'download',
            category: 'engagement',
            label: href || 'unknown_file'
          })
        })
      })
    }

    // Track video interactions
    const trackVideoInteractions = () => {
      const videos = document.querySelectorAll('video')
      videos.forEach((video) => {
        video.addEventListener('play', () => {
          event({
            action: 'video_play',
            category: 'engagement',
            label: video.src || 'unknown_video'
          })
        })
        
        video.addEventListener('pause', () => {
          event({
            action: 'video_pause',
            category: 'engagement',
            label: video.src || 'unknown_video'
          })
        })
        
        video.addEventListener('ended', () => {
          event({
            action: 'video_complete',
            category: 'engagement',
            label: video.src || 'unknown_video'
          })
        })
      })
    }

    // Track scroll depth
    const trackScrollDepth = () => {
      let maxScroll = 0
      const trackScroll = () => {
        const scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100)
        
        if (scrollPercent > maxScroll) {
          maxScroll = scrollPercent
          
          // Track at 25%, 50%, 75%, and 100%
          if ([25, 50, 75, 100].includes(maxScroll)) {
            event({
              action: 'scroll',
              category: 'engagement',
              label: `${maxScroll}%`,
              value: maxScroll
            })
          }
        }
      }
      
      window.addEventListener('scroll', trackScroll)
      
      return () => window.removeEventListener('scroll', trackScroll)
    }

    // Initialize all tracking
    const cleanupFunctions = [
      trackFormInteractions(),
      trackOutboundLinks(),
      trackFileDownloads(),
      trackVideoInteractions(),
      trackScrollDepth()
    ]

    // Cleanup function
    return () => {
      cleanupFunctions.forEach(cleanup => {
        if (typeof cleanup === 'function') {
          cleanup()
        }
      })
    }
  }, [])

  return null
} 